<template>
  <div>
    <RecordComponent/>
  </div>
</template>

<script>
import RecordComponent from "@/components/Record.vue";
export default {
  name: "RecordView",
  components: {
    RecordComponent
  },
};
</script>

